export enum ColoringMode {
    SingleColor = 0,
    BySerie = 1
}